var buildFormattingTokensRegExp = require('date-fns/locale/_lib/build_formatting_tokens_reg_exp/index.js')

function buildFormatLocale() {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = [
    'जन',
    'फर',
    'मार्च',
    'अप्रेल',
    'मई',
    'जून',
    'जूलाई',
    'अग',
    'सित',
    'अक्ट',
    'नव',
    'दि',
  ]
  var monthsFull = [
    'जनवरी ',
    'फरवरी',
    'मार्च',
    'अप्रेल',
    'मई',
    'जून',
    'जूलाई',
    'अगस्त ',
    'सितम्बर',
    'अक्टूबर',
    'नवम्बर',
    'दिसम्बर',
  ]
  var weekdays2char = ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि']
  var weekdays3char = ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि']
  var weekdaysFull = [
    'रविवार',
    'सोमवार',
    'मंगलवार',
    'बुधवार',
    'गुरुवार',
    'शुक्रवार',
    'शनिवार',
  ]
  var meridiemUppercase = ['पूर्वाह्न', 'अपराह्न']
  var meridiemLowercase = ['पूर्वाह्न', 'अपराह्न']
  var meridiemFull = ['पूर्वाह्न', 'अपराह्न']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    MMM: function(date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    MMMM: function(date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    dd: function(date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    ddd: function(date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    dddd: function(date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    A: function(date) {
      return date.getHours() / 12 >= 1
        ? meridiemUppercase[1]
        : meridiemUppercase[0]
    },

    // am, pm
    a: function(date) {
      return date.getHours() / 12 >= 1
        ? meridiemLowercase[1]
        : meridiemLowercase[0]
    },

    // a.m., p.m.
    aa: function(date) {
      return date.getHours() / 12 >= 1 ? meridiemFull[1] : meridiemFull[0]
    },
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function(formatterToken) {
    formatters[formatterToken + 'o'] = function(date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters),
  }
}

function ordinal(number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 0:
        return number
      case 1:
        return number + 'ला'
      case 2:
      case 3:
        return number + 'रा'
      case 4:
        return number + 'था'
      case 6:
        return number + 'टा'
    }
  }
  return number + 'वाँ'
}

module.exports = buildFormatLocale
